import { render, staticRenderFns } from "./ConfirmAdvertisementButton.vue?vue&type=template&id=d01806fe&"
import script from "./ConfirmAdvertisementButton.vue?vue&type=script&lang=ts&"
export * from "./ConfirmAdvertisementButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports